<div class="broker">
  <div *ngIf="showExternal" class="broker__external">
    <mat-checkbox
      id="external_broker_checkbox-{{index}}"
      [ngClass]="{ 'external-fee-influencer' : isFeeInfluencer }"
      [(ngModel)]="isExternal"
      name="isExternal"
      (change)="brokerSelectionChange()"
      color="primary">
      <span *ngIf="checkboxLabel">{{checkboxLabel}}</span>
      <span *ngIf="!checkboxLabel" i18n>Conjunctional Agent</span>
    </mat-checkbox>
  </div>
  <div class="broker__info">
    <div class="broker__info__image" [ngClass]="{ 'align-fee-influencer' : isFeeInfluencer }">
      <div class="initials" [class.external]="isExternal">{{ brokerInitials }}</div>
    </div>
    <div *ngIf="!isExternal" class="broker__info__namenemail" [ngClass]="{ 'align-fee-influencer' : isFeeInfluencer }">
      <div class="formfields">
        <div class="formfields__container no-padding">
          <mat-form-field>
            <label *ngIf="showBrokerSearchLabel"
              class="screen-readers-only" for="broker-search-{{index}}" i18n>
              Search
            </label>
            <input
              id="broker-name-{{index}}"
              matInput
              #brokerInput
              i18n-placeholder
              [value]="displayForContactName"
              [matAutocomplete]="brokerAutocomplete"
              (keyup)="getSuggestions(brokerInput.value, $event)"
              [disabled]="viewOnly || disabled"
              />
            <mat-icon *ngIf="!viewOnly && !disabled" matSuffix>search</mat-icon>
            <ng-container *ngIf="disabled">
              <span class="spinner-wrapper">
                <mat-spinner diameter="20" ></mat-spinner>
              </span>
            </ng-container>
            <mat-autocomplete #brokerAutocomplete>
              <mat-option *ngFor="let brokerSuggestion of brokerSuggestions$ | async"
                [value]="brokerSuggestion.preferred_name"
                (onSelectionChange)="brokerSelectionChange(brokerSuggestion)"
                (click)="brokerSelectionChange(brokerSuggestion)">
                <span class="dropdown-tooltip  broker-search-{{brokerSuggestion.emplid}}"
                  matTooltip="Employee Id: {{ brokerSuggestion?.emplid }}
                  Country: {{ brokerSuggestion?.reg_region }}
                  Functional Unit: {{ brokerSuggestion?.functional_unit?.name }}
                  Managing Office: {{ brokerSuggestion?.managing_office?.name }}
                  Preferred Name: {{ brokerSuggestion?.preferred_name }}
                  Business Unit: {{ brokerSuggestion?.business_unit }}">
                  {{ brokerSuggestion?.preferred_name }}
                </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <div *ngIf="showEmail" [ngClass]="{ 'disabled-display': viewOnly }">
            {{email || '&nbsp;'}}
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isExternal" class="broker__info__namenemail" [ngClass]="{ 'align-external-fee-influencer' : isFeeInfluencer }">
      <div class="formfields">
        <div class="formfields__container no-padding">
          <form [formGroup]="brokerForm">
            <mat-form-field>
              <label *ngIf="isExternal && !crossBorder" class="screen-readers-only" for="broker-name" i18n>Search</label>
              <input
                id="broker-name-{{index}}"
                formControlName="name"
                matInput
                #externalBrokerInput
                i18n-placeholder
                [value]="displayForContactName"
                [matAutocomplete]="brokerAutocomplete"
                (keyup)="getSuggestions(externalBrokerInput.value, $event)"
                (blur)="onBlurSaveBroker(externalBrokerInput.value)"
              />
              <mat-icon *ngIf="!viewOnly && !disabled" matSuffix>search</mat-icon>
              <ng-container *ngIf="disabled">
                <span class="spinner-wrapper">
                  <mat-spinner diameter="20" ></mat-spinner>
                </span>
              </ng-container>
              <mat-autocomplete #brokerAutocomplete>
                <mat-option *ngFor="let brokerSuggestion of brokerSuggestions$ | async"
                  [value]="brokerSuggestion.name"
                  (onSelectionChange)="brokerSelectionChange(brokerSuggestion)"
                  (click)="brokerSelectionChange(brokerSuggestion)">
                  <span class="dropdown-tooltip  broker-search-{{brokerSuggestion.emplid}}"
                    matTooltip="Employee Id: {{ brokerSuggestion?.emplid }}
                    Country: {{ brokerSuggestion?.reg_region }}
                    Functional Unit: {{ brokerSuggestion?.functional_unit?.name }}
                    Managing Office: {{ brokerSuggestion?.managing_office?.name }}
                    Name: {{ brokerSuggestion?.name }}">
                    {{ brokerSuggestion?.name }}
                  </span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div *ngIf="showEmail" class="email">
              <mat-form-field floatPlaceholder="never">
                <input id="broker-email-{{index}}" type="email" matInput [(ngModel)]="email" placeholder="Email" i18n-placeholder formControlName="email"/>
              </mat-form-field>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
